'use client';

import { c as _c } from "react/compiler-runtime";
import { Memo, Show, reactive, useComputed } from '@legendapp/state/react';
import { $React } from '@legendapp/state/react-web';
import type { ReactNode } from 'react';
import { batch } from '@legendapp/state';
import { FieldWarning } from '@/components/FieldWarning';
import { useHeroBlockSearchFormState } from '@/components/forms/HeroBlockSearchForm/HeroBlockSearchFormProvider';
import { HeroSearchFormColumnButton, type HeroSearchFormColumnButtonProps } from '@/components/forms/HeroBlockSearchForm/components/HeroSearchFormColumnButton';
import { useSearchFromContext } from '@/components/forms/SearchFromProvider';
import { LocationSelect } from '@/components/forms/fields/LocationSelect/LocationSelect';
import PromoCodeField from '@/components/forms/fields/PromoCodeField';
import { cn } from '@/lib/cn';
export type HeroSearchFormLocationSelectProps = HeroSearchFormColumnButtonProps;
const ReactiveLocationSelect = reactive(LocationSelect);
const ReactiveHeroSearchFormColumnButton = reactive(HeroSearchFormColumnButton);
const ReactivePromoCodeField = reactive(PromoCodeField);
export function HeroSearchFormLocationSelect(t0) {
  const $ = _c(94);
  let cardProps;
  let className;
  let description;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      description,
      cardProps,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = cardProps;
    $[2] = className;
    $[3] = description;
    $[4] = props;
  } else {
    cardProps = $[1];
    className = $[2];
    description = $[3];
    props = $[4];
  }
  const {
    triggerId$,
    values,
    variant$,
    warnings$
  } = useHeroBlockSearchFormState();
  const formState$ = useSearchFromContext();
  let t1;
  if ($[5] !== formState$ || $[6] !== values.pickUpBranch) {
    t1 = () => formState$.getBranchByCode(values.pickUpBranch.get());
    $[5] = formState$;
    $[6] = values.pickUpBranch;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const selectedPickUpBranch$ = useComputed(t1);
  let t2;
  if ($[8] !== formState$ || $[9] !== values.dropOffBranch) {
    t2 = () => formState$.getBranchByCode(values.dropOffBranch.get());
    $[8] = formState$;
    $[9] = values.dropOffBranch;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const selectedDropOffBranch$ = useComputed(t2);
  let t3;
  if ($[11] !== selectedDropOffBranch$ || $[12] !== selectedPickUpBranch$) {
    t3 = () => {
      const pickUpBranch = selectedPickUpBranch$.get();
      const dropOffBranch = selectedDropOffBranch$.get();
      return pickUpBranch?.siteCode && dropOffBranch?.siteCode && pickUpBranch.countryCode === dropOffBranch.countryCode;
    };
    $[11] = selectedDropOffBranch$;
    $[12] = selectedPickUpBranch$;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const valid = useComputed(t3);
  let t4;
  if ($[14] !== selectedDropOffBranch$ || $[15] !== selectedPickUpBranch$ || $[16] !== valid) {
    t4 = () => {
      const pickUpBranch_0 = selectedPickUpBranch$.get();
      const dropOffBranch_0 = selectedDropOffBranch$.get();
      if (valid.get()) {
        return "Continue";
      }
      if (pickUpBranch_0?.siteCode && !dropOffBranch_0?.siteCode) {
        return "Select drop off location";
      }
      if (!pickUpBranch_0?.siteCode && dropOffBranch_0?.siteCode) {
        return "Select pick up location";
      }
      return "Select pick up & drop off";
    };
    $[14] = selectedDropOffBranch$;
    $[15] = selectedPickUpBranch$;
    $[16] = valid;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const btnLabel = useComputed(t4);
  let t5;
  if ($[18] !== formState$.dropOffBranch || $[19] !== formState$.pickUpBranch || $[20] !== values.dropOffBranch || $[21] !== values.pickUpBranch) {
    t5 = function resetInternalState() {
      const oldPickUpBranch = formState$.pickUpBranch.get();
      const oldDropOffBranch = formState$.dropOffBranch.get();
      batch(() => {
        if (oldPickUpBranch) {
          values.pickUpBranch.set(oldPickUpBranch);
        } else {
          values.pickUpBranch.delete();
        }
        if (oldDropOffBranch) {
          values.dropOffBranch.set(oldDropOffBranch);
        } else {
          values.pickUpBranch.delete();
        }
      });
    };
    $[18] = formState$.dropOffBranch;
    $[19] = formState$.pickUpBranch;
    $[20] = values.dropOffBranch;
    $[21] = values.pickUpBranch;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const resetInternalState = t5;
  let t6;
  if ($[23] !== formState$.dropOffBranch || $[24] !== formState$.pickUpBranch || $[25] !== resetInternalState || $[26] !== valid || $[27] !== values.dropOffBranch || $[28] !== values.pickUpBranch) {
    t6 = function handleClose() {
      if (valid.get()) {
        batch(() => {
          formState$.pickUpBranch.set(values.pickUpBranch.get());
          formState$.dropOffBranch.set(values.dropOffBranch.get());
        });
      } else {
        resetInternalState();
      }
    };
    $[23] = formState$.dropOffBranch;
    $[24] = formState$.pickUpBranch;
    $[25] = resetInternalState;
    $[26] = valid;
    $[27] = values.dropOffBranch;
    $[28] = values.pickUpBranch;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  const handleClose = t6;
  let t7;
  if ($[30] !== variant$) {
    t7 = () => variant$.get() === "vertical";
    $[30] = variant$;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== triggerId$) {
    t8 = () => {
      triggerId$.set("fleet-type");
    };
    $[32] = triggerId$;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== className) {
    t9 = cn("border-y-0 border-r border-l-0 flex-1 min-w-0 max-w-69 basis-69", className);
    $[34] = className;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  const t10 = cardProps?.className;
  let t11;
  if ($[36] !== t10) {
    t11 = cn("lg:[&_.card-body]:pb-0 lg:[&_.card-body]:pr-0 [&_.card-body]:overflow-y-auto [&_.card-body]:overflow-x-hidden", t10);
    $[36] = t10;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== cardProps || $[39] !== t11) {
    t12 = {
      ...cardProps,
      "data-testid": "location-card",
      className: t11
    };
    $[38] = cardProps;
    $[39] = t11;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== description || $[42] !== formState$) {
    t13 = () => {
      const pickUpBranch_1 = formState$.getPickUpBranch();
      const dropOffBranch_1 = formState$.getDropOffBranch();
      if (pickUpBranch_1 && dropOffBranch_1) {
        const pickUpBranchLabel = pickUpBranch_1.name.replace(/Airport/i, "").trim();
        const dropOffBranchLabel = dropOffBranch_1.name.replace(/Airport/i, "").trim();
        return `${pickUpBranchLabel} → ${dropOffBranchLabel}`;
      }
      return description;
    };
    $[41] = description;
    $[42] = formState$;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== variant$) {
    t14 = () => variant$.get();
    $[44] = variant$;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== values.dropOffBranch || $[47] !== values.pickUpBranch || $[48] !== warnings$.dropOffBranch || $[49] !== warnings$.pickUpBranch) {
    t15 = () => ({
      pickUp: {
        name: "pickUpLocation",
        placeholder: "Select pick up location",
        value: values.pickUpBranch.get(),
        onChange: e => {
          if (!e?.target.value) {
            values.pickUpBranch.delete();
          } else {
            warnings$.pickUpBranch.delete();
            values.pickUpBranch.set(e.target.value);
          }
        },
        label: "Select airport pick up location"
      },
      dropOff: {
        name: "dropOffLocation",
        placeholder: "Select drop off location",
        value: values.dropOffBranch.get(),
        onChange: e_0 => {
          if (!e_0?.target.value) {
            values.dropOffBranch.delete();
          } else {
            warnings$.dropOffBranch?.delete();
            values.dropOffBranch.set(e_0.target.value);
          }
        },
        label: "Select airport drop off location"
      }
    });
    $[46] = values.dropOffBranch;
    $[47] = values.pickUpBranch;
    $[48] = warnings$.dropOffBranch;
    $[49] = warnings$.pickUpBranch;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== warnings$.dropOffBranch) {
    t16 = () => {
      warnings$.dropOffBranch.set(<><strong>Same-country</strong>{" pick up & drop off only"}</>);
    };
    $[51] = warnings$.dropOffBranch;
    $[52] = t16;
  } else {
    t16 = $[52];
  }
  let t17;
  if ($[53] !== formState$.regions) {
    t17 = formState$.regions.get();
    $[53] = formState$.regions;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  let t18;
  if ($[55] !== warnings$.dropOffBranch || $[56] !== warnings$.pickUpBranch) {
    t18 = () => {
      const pickUpBranchWarning = warnings$.pickUpBranch?.get() as ReactNode;
      const dropOffBranchWarning = warnings$.dropOffBranch?.get() as ReactNode;
      if (!pickUpBranchWarning && !dropOffBranchWarning) {
        return null;
      }
      return <>{pickUpBranchWarning ? <FieldWarning>{pickUpBranchWarning}</FieldWarning> : null}{dropOffBranchWarning ? <FieldWarning>{dropOffBranchWarning}</FieldWarning> : null}</>;
    };
    $[55] = warnings$.dropOffBranch;
    $[56] = warnings$.pickUpBranch;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  let t19;
  if ($[58] !== valid) {
    t19 = () => !valid.get();
    $[58] = valid;
    $[59] = t19;
  } else {
    t19 = $[59];
  }
  let t20;
  if ($[60] !== handleClose || $[61] !== triggerId$) {
    t20 = () => {
      handleClose();
      triggerId$.set("dates");
    };
    $[60] = handleClose;
    $[61] = triggerId$;
    $[62] = t20;
  } else {
    t20 = $[62];
  }
  let t21;
  if ($[63] !== btnLabel) {
    t21 = <Memo>{() => btnLabel.get()}</Memo>;
    $[63] = btnLabel;
    $[64] = t21;
  } else {
    t21 = $[64];
  }
  let t22;
  if ($[65] !== t19 || $[66] !== t20 || $[67] !== t21) {
    t22 = <$React.button className="btn btn-primary h-13 mt-auto " data-testid="location-continue-btn" $disabled={t19} onClick={t20}>{t21}</$React.button>;
    $[65] = t19;
    $[66] = t20;
    $[67] = t21;
    $[68] = t22;
  } else {
    t22 = $[68];
  }
  let t23;
  if ($[69] !== variant$) {
    t23 = () => variant$.get() === "vertical";
    $[69] = variant$;
    $[70] = t23;
  } else {
    t23 = $[70];
  }
  let t24;
  if ($[71] !== formState$.promoCode) {
    t24 = () => <div className="mx-auto"><ReactivePromoCodeField labelClassName="text-primary" label="Promo code" $value={() => formState$.promoCode.get()} onChange={e_1 => formState$.promoCode.set(e_1.target.value?.trim())} /></div>;
    $[71] = formState$.promoCode;
    $[72] = t24;
  } else {
    t24 = $[72];
  }
  let t25;
  if ($[73] !== t23 || $[74] !== t24) {
    t25 = <Show if={t23}>{t24}</Show>;
    $[73] = t23;
    $[74] = t24;
    $[75] = t25;
  } else {
    t25 = $[75];
  }
  let t26;
  if ($[76] !== t22 || $[77] !== t25) {
    t26 = <>{t22}{t25}</>;
    $[76] = t22;
    $[77] = t25;
    $[78] = t26;
  } else {
    t26 = $[78];
  }
  let t27;
  if ($[79] !== t14 || $[80] !== t15 || $[81] !== t16 || $[82] !== t17 || $[83] !== t18 || $[84] !== t26) {
    t27 = <ReactiveLocationSelect $variant={t14} $fieldOptions={t15} onRegionChange={t16} $regions={t17} $header={t18} footer={t26} />;
    $[79] = t14;
    $[80] = t15;
    $[81] = t16;
    $[82] = t17;
    $[83] = t18;
    $[84] = t26;
    $[85] = t27;
  } else {
    t27 = $[85];
  }
  let t28;
  if ($[86] !== props || $[87] !== t12 || $[88] !== t13 || $[89] !== t27 || $[90] !== t7 || $[91] !== t8 || $[92] !== t9) {
    t28 = <ReactiveHeroSearchFormColumnButton $showBack={t7} onBack={t8} className={t9} cardProps={t12} $description={t13} data-testid="location-select" data-hero-field="locations" {...props}>{t27}</ReactiveHeroSearchFormColumnButton>;
    $[86] = props;
    $[87] = t12;
    $[88] = t13;
    $[89] = t27;
    $[90] = t7;
    $[91] = t8;
    $[92] = t9;
    $[93] = t28;
  } else {
    t28 = $[93];
  }
  return t28;
}